import React, { useState } from "react";
import { Loader2, Receipt, Send, CheckCircle2, AlertTriangle, Mail, MessageSquare } from "lucide-react";
import { toast } from "../ui/sonner";
import { fmtDT } from "../../lib/date";

/* 财务铃铛「Change Order 已签字，待开 Invoice」：一键 登记 Invoice → 邮件附 PDF + 短信发业主 → 完成财务待办；完成后原地显示「已开票 · 已发送」。 */
export function CoInvoiceOneClick({ r, api, zh, user, onDone }) {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(r.done || null);
  const canInvoice = ["finance", "admin", "ceo"].includes(user?.role);
  const c = r.ownerContact || {};
  if (res) {
    return (
      <div className="mt-1.5 inline-flex flex-wrap items-center gap-1.5 text-[11px] rounded-md border border-emerald-200 bg-emerald-50 px-2 py-1 text-emerald-800" data-testid={`co-invoice-done-${r.id}`} data-invoice={res.invoiceNumber || ""}>
        <CheckCircle2 className="h-3.5 w-3.5" />
        <span className="font-semibold">{zh ? "已开票" : "Invoiced"} {res.invoiceNumber}</span>
        {(res.sent || []).length > 0 ? <span>· {zh ? "已发送" : "sent"} {res.sent.includes("email") && <Mail className="h-3 w-3 inline" />}{res.sent.includes("email") ? ` ${res.to?.email || ""}` : ""}{res.sent.includes("sms") && <MessageSquare className="h-3 w-3 inline ml-1" />}{res.sent.includes("sms") ? ` ${res.to?.phone || ""}` : ""}</span>
          : <span className="text-amber-700 inline-flex items-center gap-0.5"><AlertTriangle className="h-3 w-3" />{zh ? "未发送" : "not sent"}{(res.errors || []).length ? `：${res.errors.join("；")}` : ""}</span>}
        <span className="text-emerald-600/70">· {res.by} {fmtDT(res.at)}</span>
      </div>
    );
  }
  if (!canInvoice) return null;
  const go = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post(`/change-orders/${r.coId}/invoice/create-and-send`, {});
      setRes(data.done || data);
      const bits = [zh ? `Invoice ${data.invoiceNumber} ${data.created ? "已登记" : "已存在"}` : `Invoice ${data.invoiceNumber} ${data.created ? "created" : "exists"}`];
      if ((data.sent || []).length) bits.push(zh ? `已发送业主：${data.sent.map((s) => (s === "email" ? "邮件" : "短信")).join(" + ")}` : `sent: ${data.sent.join(" + ")}`);
      if ((data.errors || []).length) bits.push(data.errors.join("；"));
      ((data.sent || []).length ? toast.success : toast.warning)(bits.join(" · "), { duration: 9000 });
      onDone?.(data);
    } catch (err) { toast.error(err?.response?.data?.detail || (zh ? "开票失败" : "Failed")); }
    setBusy(false);
  };
  const noContact = !c.email && !c.phone;
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-2">
      <button type="button" data-testid={`co-invoice-oneclick-${r.id}`} disabled={busy} onClick={go}
        className="inline-flex items-center gap-1 text-[11px] font-semibold text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 rounded-lg px-2.5 py-1">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Receipt className="h-3 w-3" />}{zh ? "生成并发送 Invoice" : "Create & send invoice"}<Send className="h-3 w-3" />
      </button>
      <span className="text-[10px] text-slate-500" data-testid={`co-invoice-oneclick-to-${r.id}`}>
        {noContact ? <span className="text-amber-700 inline-flex items-center gap-0.5"><AlertTriangle className="h-3 w-3" />{zh ? "业主无邮箱 / 手机号：只登记 Invoice，不会外发" : "Owner has no email / phone: invoice only"}</span>
          : <>{zh ? "发送给" : "To"} {c.name ? `${c.name} · ` : ""}{c.email && <span className="inline-flex items-center gap-0.5"><Mail className="h-3 w-3" />{c.email}</span>}{c.email && c.phone ? " · " : ""}{c.phone && <span className="inline-flex items-center gap-0.5"><MessageSquare className="h-3 w-3" />{c.phone}</span>}</>}
      </span>
    </div>
  );
}
